/**
 * @class
 * @classdesc Model for Booking on DB
 * * */
export default class Booking {
  /**
   * Constructor
   * @param {Number} id
   * @param {Number} placeId
   * @param {String} startTime
   * @param {String} endTime
   * @param {String} licencePlate
   * @param {String} name
   * @param {String} phone
   * @param {String} email
   * @param {String} extraBookingNumber
   * @param {String} comments
   */

  #BookingObject = {}

  constructor(
    id,
    placeId,
    startTime,
    endTime,
    licensePlate,
    name,
    phone,
    email,
    extraBookingNumber,
    comments
  ) {
    this.#BookingObject.ID = id || null
    this.#BookingObject.PlaceID = placeId || null
    this.#BookingObject.StartTime = startTime || null
    this.#BookingObject.EndTime = endTime || null
    this.#BookingObject.LicensePlate = licensePlate || ''
    this.#BookingObject.Name = name || ''
    this.#BookingObject.Phone = phone || ''
    this.#BookingObject.Email = email || ''
    this.#BookingObject.ExtraBookingNumber = extraBookingNumber || ''
    this.#BookingObject.Comments = comments || ''
  }

  /**
   * Get Booking Object
   * @return {Object} Booking Javascript object
   */
  getObject() {
    return this.#BookingObject
  }
}
